import { Component, Inject } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { FlexLayoutModule, FlexModule } from '@ngbracket/ngx-layout';
import { NgFor, NgIf } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list'
@Component({
  selector: 'app-verify-capture-dialog',
  standalone: true,
  imports: [NgFor, NgIf, MatDialogModule, MatDividerModule, MatButtonModule, FlexLayoutModule, FlexModule, MatListModule],
  template: `
<div class="saving-content">
<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <path d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM22 30H18V18H22V30ZM22 14H18V10H22V14Z" fill="url(#paint0_linear_2700_33)"/>
  <defs>
    <linearGradient id="paint0_linear_2700_33" x1="1.53191" y1="2.25352" x2="41.7548" y2="19.9058" gradientUnits="userSpaceOnUse">
      <stop stop-color="#B9AB1C"/>
      <stop offset="1" stop-color="#8E8501"/>
    </linearGradient>
  </defs>
</svg>
  <label class="dialogHeader" style="padding-top: 28px;">Verify Meter Reading</label>
<mat-list class="readings-list">

  @for (r of data.readings; track $index; let last = $last) {
    <mat-list-item class="readings-item">
      <div class="row">
        <span class="label">{{ r.label }}</span>
        <span class="value">{{ r.value }}</span>
      </div>
    </mat-list-item>

    @if (!last) {
      <mat-divider></mat-divider>
    }
  }

</mat-list>


  <div class="devider"></div>

  <div fxLayout="row" fxLayoutAlign="space-between end" fxLayoutGap="8" style="width:100%; padding-top:12px; padding-left: 0px; padding-right: 0px;">
    <button mat-button style="width: 100%; background:#fff !important" (click)="close()">Edit</button>
    <button mat-flat-button color="warn" style="width: 100%;" (click)="continue()">Confirm</button>
  </div>
</div>

`, styles: [`
.dialogHeader{
  color: var(--color-greyscale-text-main, #343637);
font-size: 18px;
font-style: normal;
font-weight: 600;
line-height: 130%; /* 20.8px */
}
.readings-list {
  width: 100%;
  padding: 0;
}

.readings-item {
  padding: 14px 0 !important;
}

.row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label {
overflow: hidden;
color: var(--greyscale-text-main, #060809);
text-overflow: ellipsis;
font-family: Roboto;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 142.857% */
letter-spacing: 0.25px;
}

.value {
overflow: hidden;
color: var(--greyscale-text-main, #060809);
text-overflow: ellipsis;
font-family: Roboto;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 20px; 
letter-spacing: 0.25px;
}

.mat-divider {
    display: block;
    margin: 0;
    border-top-style: solid;
    border-top-color: var(--greyscale-divider-light, #E2E2E2) !important;
    border-top-width: var(--mat-divider-width, 1px);
}
  .mat-mdc-button:not(:disabled) {
  border-radius: 4px;
  border: 1px solid var(--greyscale-border-light, #e2e2e2);
   color:  #060809 !important;
   background: #fff !important;
}
::ng-deep .mdc-dialog--open .mat-mdc-dialog-surface, .mdc-dialog--closing .mat-mdc-dialog-surface {
    transform: none;
    background: none !important;
}
/* Content Styles */
.saving-content,
.message-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 36px 24px 36px 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  max-width: 100%;
}

.saving-content h3,
.message-content h3 {
  margin: 1rem 0 0.5rem 0;
  color: #333;
  font-weight: 500;
}

.saving-content p,
.message-content p {
  margin: 0 0 1rem 0;
  color: #666;
  font-size: 0.9rem;
}
    .warning {
      color: #e53935 !important;
      font-weight: 500;
    }
   ::ng-deep .mat-mdc-button:not(:disabled):hover, .mat-mdc-button:not(:disabled):focus{
  background: #fff !important;
}
  

  `]
})
export class VerifyCaptureDialog {
  readings = []
  constructor(private dialogRef: MatDialogRef<VerifyCaptureDialog>, private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(this.data.readings)
    this.readings = this.data.readings
    console.log(this.readings)
  }
  close() {
    this.dialogRef.close('close');     // return "sync"
  }

  continue() {
    this.dialogRef.close('submit'); // return "continue"
  }
}
